import './scss/loading-splash-page.scss';

export const LoadingSplashPage = () => {

    return (
        <div className='lex-loading-splash-page'>
            <h1>LEX - Program legislatie</h1>
            <h2>Loading ... </h2>
        </div>
    )
}